<div class="card cardMeasurements" [class.border-danger]="unavailableText">
  <div class="card-body">
    <div>
      @if (unavailableText) {
        <div class="alert alert-danger py-2 mb-2" role="alert">
          {{ unavailableText }}
        </div>
      }
      <div class="row mb-2">
        <div class="productImage col-sm-3">
          <img [src]="image" class="img-fluid" alt="" />

          @if (cartItem().files[0]?.imageUrls.length > 0) {
            <img [src]="cartItem().files[0].imageUrls[0].mediumImageUrl"
              class="img-fluid" alt="" />
          }
        </div>
        <div class="col-sm-6">
          <h5 class="card-title mb-1 d-block NameLabel">
            <!-- A deleted Sku arrives degraded from the BFF (no name/price) — #507 G1. -->
            @if (cartItem().skuName1) {
              {{ cartItem().skuName1 }}
            } @else {
              <span class="text-muted" i18n>Artikel nicht mehr verfügbar</span>
            }
          </h5>
          @if (cartItem().unavailableReason !== 'notFound') {
            <h5 class="d-block">
              {{ cartItem().unitGrossPrice | currency: cartItem().currency }}
            </h5>
            <p i18n>Anbieter: {{ cartItem().sellerFullName }}</p>
          }
        </div>
      </div>
      <div>
        <app-edit-cart-item [cartPosition]="cartItem()"></app-edit-cart-item>
      </div>
    </div>
  </div>
</div>